import Vue from 'vue'
import Router from 'vue-router'
import SignIn from '@/components/login/signin'
import LoginRecovery from '@/components/login/recovery'
import LoginReset from '@/components/login/reset'
import Home from '@/components/home/index'
import UserView from '@/components/users/users'
import MediaView from '@/components/media/view'
import CKMedia from '@/components/media/popup'
import GalleryGroupsView from '@/components/gallery_groups/groups'
import GalleryView from '@/components/galleries/galleries'
import ProductView from '@/components/products/products'
import InventoryView from '@/components/inventory/inventory'
import AttributesView from '@/components/attributes/attributes'
import DiscountTypes from '@/components/discount_types/types'
import GalleryImagesView from '@/components/gallery_images/images'
import PagesView from '@/components/pages/pages'
import ProductCategories from '@/components/product_categories/categories'
import DiscountCupons from '@/components/discount_cupons/cupons'
import ShoppingCarts from '@/components/shopping_carts/carts'
import Orders from '@/components/orders/orders'
import FreeShiping from '@/components/free_shipping/free.shipping'
import ProductBrands from '@/components/designers/designers'

import { auth } from '@/core/libs/sessions'

Vue.use(Router)

const router = new Router({
	routes: [
		{
			path: '/login/signin',
			name: 'signIn',
			component: SignIn,
			meta: {
				auth: false,
				roles: null
			}
		},
		{
			path: '/login/recovery',
			name: 'recoveryLogin',
			component: LoginRecovery,
			meta: {
				auth: false,
				roles: null
			}
		},
		{
			path: '/login/reset',
			name: 'resetLogin',
			component: LoginReset,
			meta: {
				auth: false,
				roles: null
			}
		},
		{
			path: '/',
			name: 'home',
			component: Home,
			meta: {
				auth: true,
				roles: [1, 2, 3]
			}
		},
		{
			path: '/usuarios',
			name: 'userView',
			component: UserView,
			meta: {
				auth: true,
				roles: [1, 2, 3]
			}
		},
		{
			path: '/paginas',
			name: 'pagesView',
			component: PagesView,
			meta: {
				auth: true,
				roles: [1, 2, 3]
			}
		},
		{
			path: '/marcas',
			name: 'brandView',
			component: ProductBrands,
			meta: {
				auth: true,
				roles: [1, 2, 3]
			}
		},
		{
			path: '/galerias/grupos',
			name: 'galleryGroupsView',
			component: GalleryGroupsView,
			meta: {
				auth: true,
				roles: [1, 2, 3]
			}
		},
		{
			path: '/galerias/imagenes/:id',
			name: 'galleryImagesView',
			component: GalleryImagesView,
			meta: {
				auth: true,
				roles: [1, 2, 3]
			}
		},
		{
			path: '/galerias',
			name: 'galleryView',
			component: GalleryView,
			meta: {
				auth: true,
				roles: [1, 2, 3]
			}
		},
		{
			path: '/productos/:id',
			name: 'inventoryView',
			component: InventoryView,
			meta: {
				auth: true,
				roles: [1, 2, 3]
			}
		},
		{
			path: '/productos',
			name: 'productView',
			component: ProductView,
			meta: {
				auth: true,
				roles: [1, 2, 3]
			}
		},
		{
			path: '/categorias-de-productos',
			name: 'productCategoryView',
			component: ProductCategories,
			meta: {
				auth: true,
				roles: [1, 2, 3]
			}
		},
		{
			path: '/tipos-de-descuento',
			name: 'discountTypes',
			component: DiscountTypes,
			meta: {
				auth: true,
				roles: [1, 2, 3]
			}
		},
		{
			path: '/atributos',
			name: 'attributesView',
			component: AttributesView,
			meta: {
				auth: true,
				roles: [1, 2, 3]
			}
		},
		{
			path: '/paginas',
			name: 'pagesView',
			component: PagesView,
			meta: {
				auth: true,
				roles: [1, 2, 3]
			}
		},
		{
			path: '/envios-gratis',
			name: 'freeShipping',
			component: FreeShiping,
			meta: {
				auth: true,
				roles: [1, 2, 3]
			}
		},
		{
			path: '/cupones-de-descuento',
			name: 'discountCupons',
			component: DiscountCupons,
			meta: {
				auth: true,
				roles: [1, 2, 3]
			}
		},
		{
			path: '/carritos-abiertos',
			name: 'shoppingCarts',
			component: ShoppingCarts,
			meta: {
				auth: true,
				roles: [1, 2, 3]
			}
		},
		{
			path: '/ordenes',
			name: 'orders',
			component: Orders,
			meta: {
				auth: true,
				roles: [1, 2, 3]
			}
		},
		{
			path: '/media/images',
			name: 'ckMedia',
			component: CKMedia,
			meta: {
				auth: true,
				roles: [1, 2, 3]
			}
		},
		{
			path: '/media',
			name: 'mediaView',
			component: MediaView,
			meta: {
				auth: true,
				roles: [1, 2, 3]
			}
		}
	]
})

router.beforeEach((to, from, next) => {
	auth.loggedIn(to, from).then(isAuth => {
		if (to.name) {
			if (isAuth.auth && to.name !== 'signIn') {
				next()
			} else if (isAuth.auth && to.name === 'signIn') {
				next({ path: '/' })
			} else if (!isAuth.auth && to.name !== 'signIn' && to.name !== 'recoveryLogin' && to.name !== 'resetLogin' && isAuth.route === 'login') {
				next({ path: '/login/signin' })
			} else if (!isAuth.auth && to.name === 'signIn') {
				next()
			} else {
				next()
			}
		}
	})
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js